/**
 * Prefer runtime WebP derivatives when the browser supports them.
 * Source PNGs stay in place; derivatives are sibling `.webp` files.
 */

let webpSupported: boolean | null = null;

export function supportsRuntimeWebp(): boolean {
  if (webpSupported != null) return webpSupported;
  if (typeof document === 'undefined') {
    webpSupported = false;
    return false;
  }
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    webpSupported =
      canvas.toDataURL('image/webp').startsWith('data:image/webp');
  } catch {
    webpSupported = false;
  }
  return webpSupported;
}

/** Map a PNG art URL to its runtime WebP sibling when supported. */
export function resolveRuntimeArtUrl(src: string): string {
  if (!src || !supportsRuntimeWebp()) return src;
  // Only rewrite our art PNG pipeline — leave data/blob/external alone.
  if (!/\.png(?:$|\?)/i.test(src)) return src;
  if (!/\/art\//i.test(src) && !src.includes('art/environments')) return src;
  // Character cutouts need lossless alpha — lossy WebP shows rectangular halos in Safari.
  if (/\/art\/characters\//i.test(src)) return src;
  return src.replace(/\.png(?=$|\?)/i, '.webp');
}

/** CSS url("…") helper with runtime rewrite. */
export function runtimeCssUrl(src: string): string {
  return `url("${resolveRuntimeArtUrl(src)}")`;
}
